'use client';

import { Container, Heading } from '@chakra-ui/react';
import { AuthContext } from 'providers/Auth';
import { useContext } from 'react';
import { Helmet } from 'react-helmet';
import { useNavigate, useSearchParams } from 'react-router-dom';
import { ROUTES } from 'routes';

import { LoginForm } from 'components/forms/LoginForm';
import { PagePanel } from 'components/molecules/PagePanel';
import { BaseLayout } from 'components/templates/Base/base';
import { useTrackPageView } from 'hooks/useTrackPageView';

const LoginPage = () => {
  const { user } = useContext(AuthContext);
  const navigate = useNavigate();
  const [params] = useSearchParams();

  if (user) {
    navigate(params.get('then') || ROUTES.dashboard.base.path);
  }

  useTrackPageView('Login');

  return (
    <BaseLayout>
      <Helmet>
        <title>Log back in to Temple</title>
      </Helmet>
      <PagePanel isNarrow>
        <Container variant="form" flex="1 0">
          <Heading variant="h1" textAlign="center" mb="6">
            Login
          </Heading>
          <LoginForm />
        </Container>
      </PagePanel>
    </BaseLayout>
  );
};

export default LoginPage;
